export default {
  id: 'teams_promote_a_job',
  title: 'Promote a job',
  type: 'Direct',
  relations: [ 'JOB' ],
  description: 'Message a selected job to your employees so they can easily share it across their network.',
  body: `<div>
    <p>[[INPUT_INTRODUCTION_TEXT]]</p>
    <h2 style="margin: 0px"><strong style='font-weight: bold;'>{{JOB_TITLE}}</strong></h2>
    <div style='display: inline-block; margin: 0px'>
      <a style='display: inline-block; color:#333' href='{{JOB_LINKEDIN_SHARE_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>LinkedIn</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{JOB_FACEBOOK_SHARE_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Facebook</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{JOB_WHATSAPP_SHARE_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>WhatsApp</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{JOB_TWITTER_SHARE_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Twitter</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{JOB_MESSENGER_SHARE_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Messenger</pre>
      </a>
    </div>
    <div>
      <p>Checkout possible matches among your LinkedIn connections.</p>
      <a style='display: inline-block; color:#333' href='{{JOB_MATCH_LINK}}'>
        <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>LinkedIn Matches</pre>
      </a>
    </div>
    <div>
      <h3>Unsure what to send? How About:</h3>
      <blockquote>[[INPUT_JOB_SHARE_TEXT]]</br><a href='{{JOB_SHARE_LINK}}'>{{JOB_SHARE_LINK}}</a></blockquote>
    </div>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following job with your network to win rewards! ...',
      defaultValue: 'Share the following job with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_JOB_SHARE_TEXT: {
      label: 'Share Text',
      placeholder: 'Are you interested in working with me as a ...',
      defaultValue: 'Are you interested in working with me as a {{JOB_TITLE}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteJob.js